var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartialfitBadgeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14881_28200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1758 18.5C22.441 18.5 22.6954 18.3946 22.8829 18.2071C23.0704 18.0196 23.1758 17.7652 23.1758 17.5C23.1758 17.2348 23.0704 16.9804 22.8829 16.7929C22.6954 16.6054 22.441 16.5 22.1758 16.5H14.1758C13.9106 16.5 13.6562 16.6054 13.4687 16.7929C13.2811 16.9804 13.1758 17.2348 13.1758 17.5C13.1758 17.7652 13.2811 18.0196 13.4687 18.2071C13.6562 18.3946 13.9106 18.5 14.1758 18.5H22.1758Z",
    fill: "#FEA100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1758 7.5C12.6528 7.5 8.17578 11.977 8.17578 17.5C8.17578 23.023 12.6528 27.5 18.1758 27.5C23.6988 27.5 28.1758 23.023 28.1758 17.5C28.1758 11.977 23.6988 7.5 18.1758 7.5ZM10.1758 17.5C10.1758 15.3783 11.0186 13.3434 12.5189 11.8431C14.0192 10.3429 16.054 9.5 18.1758 9.5C20.2975 9.5 22.3323 10.3429 23.8326 11.8431C25.3329 13.3434 26.1758 15.3783 26.1758 17.5C26.1758 19.6217 25.3329 21.6566 23.8326 23.1569C22.3323 24.6571 20.2975 25.5 18.1758 25.5C16.054 25.5 14.0192 24.6571 12.5189 23.1569C11.0186 21.6566 10.1758 19.6217 10.1758 17.5Z",
    fill: "#FEA100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14881_28200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0703,
    height: 24.0703,
    fill: "white",
    transform: "translate(6.14062 5.82031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialfitBadgeIcon);
export default __webpack_public_path__ + "static/media/Partialfit-badge-icon.bcb2de361b7f3169725d8685b03a6432.svg";
export { ForwardRef as ReactComponent };